import React from "react";
import office from "../../assets/images/home-page/CDCHospital.png";
import LocationIconTilt from "./LocationIconTilt";

export default function ContactUs() {
  return (
    <div className="md:pt-[10.75rem] pt-10">
      <div className="md:px-[2.5rem] block w-full mx-auto xl:pb-[20rem] relative">
        <div className="flex justify-center items-center w-full">
          <div className="xl:w-4/5 w-11/12 grid lg:grid-cols-2 grid-cols-1">
            <div>
              <h1
                data-aos="fade-up"
                className="xl:text-left lg:w-[80%] w-full text-center font-robout font-black text-white sm:text-6xl md:text-8xl 2xl:text-[10.25rem] 2xl:leading-[144px] capitalize text-6xl tracking-[-.03em] mt-[.25rem]"
              >
                <span>get in</span> <br />
                <span className="sm:ml-[8.5rem] ml-0">touch</span>
              </h1>
            </div>

            <div className="lg:mt-24 md:mt-16 mt-12 flex justify-center items-center leading-[1.4] text-[1.4rem]  font-robout text-white">
              <div
                data-aos="fade-up"
                data-aos-delay="200"
                className="md:w-4/5 w-full lg:block hidden"
              >
                <p>
                  Got any questions related to your diagnostic concerns?
                  <br />
                  <br />
                  A precision diagnostic is just in your neighbourhood—a call &
                  message away.
                  <br />
                  <br />
                  Your health journey starts with the right care and the right
                  step.
                </p>
              </div>
              <div
                data-aos="fade-up"
                data-aos-delay="200"
                className="md:w-4/5 lg:hidden flex flex-col gap-4 w-full"
              >
                <p> Got any questions related to your diagnostic concerns?</p>
                <p>
                  {" "}
                  A precision diagnostic is just in your neighbourhood—a call &
                  message away.
                </p>
                <p>
                  Your health journey starts with the right care and the right
                  step.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute lg:block hidden lg:-bottom-16 xl:bottom-20 2xl:bottom-3 2xl:left-[11.5rem] -z-[1]">
          <div>
            <div
              className="rounded-[2rem] opacity-[1] bg-transparent md:w-4/5 lg:w-[24rem] lg:h-[16rem] xl:w-[35rem] xl:h-[23.5rem] overflow-hidden"
              style={{ transform: "rotate(-8deg)" }}
            >
              <picture>
                <img
                  src={office}
                  data-aos="zoom-in"
                  data-aos-delay="200"
                  alt="Office View"
                  className="w-full h-full object-cover"
                />
              </picture>
            </div>
            <LocationIconTilt />
          </div>
        </div>
      </div>
    </div>
  );
}
